export default "__VITE_PUBLIC_ASSET__887c2a24__"